import { Flex, Highlight, Text } from '@chakra-ui/react';
import { ContentCardPlatformIcon } from '~/components/ContentCard/components';
import { IconBox } from '~/components/IconBox';
import { ALL_SOCIAL_PLATFORM_TYPE } from '~/constants';
import { SocialAccountType } from '~/screens/ManagePlatforms/common';

interface DataNotAvailableProps {
  notPublicPlatforms: (string | SocialAccountType)[][];
}

export const DataNotAvailable: React.FC<DataNotAvailableProps> = ({
  notPublicPlatforms,
}) => (
  <Flex
    direction="column"
    background="primary.25"
    padding={4}
    borderRadius={8}
    gap={4}
  >
    <Flex>
      <Text fontSize="lg">
        <Highlight
          query="Public data is not available,"
          styles={{ fontWeight: '500' }}
        >
          Public data is not available, click Add to associate these social
          account(s) to the Talent.
        </Highlight>
      </Text>
    </Flex>
    {notPublicPlatforms.map(([key, value]: [string, SocialAccountType]) => (
      <Flex alignItems="center" gap={1} key={key}>
        <IconBox
          icon={
            <ContentCardPlatformIcon
              boxSize={6}
              platform={key as ALL_SOCIAL_PLATFORM_TYPE}
            />
          }
          width={6}
          height={6}
        />
        <Text
          color="primary.700"
          fontSize="lg"
          lineHeight="14px"
          fontWeight={400}
        >
          @{value.handle}
        </Text>
      </Flex>
    ))}
  </Flex>
);
